// todo remove
const ISOCodeForLanguageMap = {
    1: 'sv',
    2: 'en',
    3: 'da',
    4: 'nn',
    5: 'fi',
    6: 'fr',
    7: 'et',
    8: 'es',
    9: 'de',
    10: 'it',
};

export function fiGetISOCodeForLanguage(languageId) {
    if (ISOCodeForLanguageMap.hasOwnProperty(languageId)) {
        return ISOCodeForLanguageMap[languageId];
    } else {
        return 'en';
    }
}
